module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "environment"
  }, [_c('div', {
    ref: "label",
    staticClass: "label",
    style: ({
      transform: ("translateY(" + _vm.translateY + "px)")
    })
  }, [_c('div', {
    staticClass: "label-name"
  }, [_vm._v("ENVIRONMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.workspaceMain
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "conatiner-bottom"
  }, [_c('div', {
    staticClass: "reasons"
  }, [_c('Reason', {
    attrs: {
      "icon": _vm.images.icon01,
      "title": "Taipei city view"
    }
  }), _vm._v(" "), _c('Reason', {
    attrs: {
      "icon": _vm.images.icon03,
      "title": "Free coffee & snacks"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-top"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.workspace01
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-bottom"
  }, [_c('div', {
    staticClass: "img-bottom-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.workspace02
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-bottom-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.workspace03
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c0157206"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionWork/Environment.vue
// module id = 684
// module chunks = 0